import * as React from "react"
import { useScrollRestoration } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import { Link } from "gatsby"
import Layout from "../components/layout"
import Header from "../components/header"
import Seo from "../components/seo"


import JSONData from "../assets/jsons/lunch.json";

const IndexPage = () => {
  const ulScrollRestoration = useScrollRestoration(`page-component-ul-list`)
  return (
    <Layout>
      <Seo title="Lunch Menu" />
      <Header siteTitle="Lunch Menu" />
      <ul className="homeItem-wrap" {...ulScrollRestoration}>
        {/* Drink */}
        <li className="homeItem">
          <Link to={"/detail/drink-menu"}>
            <div className="homeItem-single">
              <StaticImage 
                style={{
                  position: 'absolute',
                  left: 0,
                  top: 0,
                  width: '100%',
                  height: 'auto',
                }}
                aspectRatio={35 / 16}
                width={350}
                // height={160}
                layout="constrained"
                placeholder="blurred"
                src="../../static/drink.png"
                alt="Drink Menu"
              />
              <h3>Drink Menu</h3>
            </div>
          </Link>
        </li>
        {/* Special rolls */}
        <li className="homeItem">
          <Link to={"/detail/special-rolls"}>
            <div className="homeItem-single">
              <StaticImage 
                style={{
                  position: 'absolute',
                  left: 0,
                  top: 0,
                  width: '100%',
                  height: 'auto',
                }}
                aspectRatio={35 / 16}
                width={350}
                // height={160}
                layout="constrained"
                placeholder="blurred"
                src="../../static/special-rolls.png"
                alt="Special rolls"
              />
              <h3>Special rolls</h3>
            </div>
          </Link>
        </li>
         {/* Sushi Menu */}
        <li className="homeItem">
          <Link to={"/detail/sushi-menu"}>
            <div className="homeItem-single">
              <StaticImage 
                style={{
                  position: 'absolute',
                  left: 0,
                  top: 0,
                  width: '100%',
                  height: 'auto',
                }}
                aspectRatio={35 / 16}
                width={350}
                // height={160}
                layout="constrained"
                placeholder="blurred"
                src="../../static/sushi-menu.png"
                alt="Sushi Menu"
              />
              <h3>Sushi Menu</h3>
            </div>
          </Link>
        </li>
        {/* Omu-Rice Lunch */}
        {/* <li className="homeItem">
          <Link to={"/detail/omu-rice-lunch"}>
            <div className="homeItem-single">
              <StaticImage 
                style={{
                  position: 'absolute',
                  left: 0,
                  top: 0,
                  width: '100%',
                  height: 'auto',
                }}
                aspectRatio={35 / 16}
                width={350}
                 height={160}
                layout="constrained"
                placeholder="blurred"
                src="../../static/omu-rice.png"
                alt="Omu-Rice Lunch"
              />
              <h3>Omu-Rice Lunch</h3>
            </div>
          </Link>
        </li> */}
        {/* Lunch Special */}
        <li className="homeItem">
          <Link to={"/detail/lunch-special"}>
            <div className="homeItem-single">
              <StaticImage 
                style={{
                  position: 'absolute',
                  left: 0,
                  top: 0,
                  width: '100%',
                  height: 'auto',
                }}
                aspectRatio={35 / 16}
                width={350}
                // height={160}
                layout="constrained"
                placeholder="blurred"
                src="../../static/lunch-special.png"
                alt="Lunch Special"
              />
              <h3>Lunch Special</h3>
            </div>
          </Link>
        </li>
        {/* Bowl Special */}
        <li className="homeItem">
          <Link to={"/detail/bowl-special"}>
            <div className="homeItem-single">
              <StaticImage 
                style={{
                  position: 'absolute',
                  left: 0,
                  top: 0,
                  width: '100%',
                  height: 'auto',
                }}
                aspectRatio={35 / 16}
                width={350}
                // height={160}
                layout="constrained"
                placeholder="blurred"
                src="../../static/bowl-special.png"
                alt="Bowl Special"
              />
              <h3>Bowl Special</h3>
            </div>
          </Link>
        </li>
        {/* A La Carte */}
        <li className="homeItem">
          <Link to={"/detail/a-la-carte"}>
            <div className="homeItem-single">
              <StaticImage 
                style={{
                  position: 'absolute',
                  left: 0,
                  top: 0,
                  width: '100%',
                  height: 'auto',
                }}
                aspectRatio={35 / 16}
                width={350}
                // height={160}
                layout="constrained"
                placeholder="blurred"
                src="../../static/a-la-carte.png"
                alt="A La Carte"
              />
              <h3>A La Carte</h3>
            </div>
          </Link>
        </li>
        {/* Side order */}
        <li className="homeItem">
          <Link to={"/detail/side-order"}>
            <div className="homeItem-single">
              <StaticImage 
                style={{
                  position: 'absolute',
                  left: 0,
                  top: 0,
                  width: '100%',
                  height: 'auto',
                }}
                aspectRatio={35 / 16}
                width={350}
                // height={160}
                layout="constrained"
                placeholder="blurred"
                src="../../static/side-order.png"
                alt="Side order"
              />
              <h3>Side order</h3>
            </div>
          </Link>
        </li>
        {/* Dessert */}
        <li className="homeItem">
          <Link to={"/detail/dessert"}>
            <div className="homeItem-single">
              <StaticImage 
                style={{
                  position: 'absolute',
                  left: 0,
                  top: 0,
                  width: '100%',
                  height: 'auto',
                }}
                aspectRatio={35 / 16}
                width={350}
                // height={160}
                layout="constrained"
                placeholder="blurred"
                src="../../static/dessert.png"
                alt="Dessert"
              />
              <h3>Dessert</h3>
            </div>
          </Link>
        </li>
      </ul>
    </Layout>
  )
}

export default IndexPage
